import React from 'react';
import { Switch } from 'src/components/common/Switch';

const ANIMATION_DURATION = 500;

const AdminMode: React.FC = () => {
  const isAdminModeEnabled = localStorage.getItem('bAdminMode') === 'true';

  const handleChange = (checked: boolean) => {
    localStorage.setItem('bAdminMode', String(checked));
    setTimeout(() => window.location.reload(), ANIMATION_DURATION);
  };

  return <Switch checked={isAdminModeEnabled} onChange={() => handleChange(!isAdminModeEnabled)} />;
};

export default AdminMode;
